import React, { useState } from "react";
import AccordianContainer from "../../../coach-dashboard/tabs/your-assigments/common/AccordianContainer";
import ManageDismissedModals from "./ManageDismissedModals";
import GlobalSettings from "./GlobalSettings";

export enum MasterTabKeys {
  MEASUREMENTS = "measurements",
  RACES = "races",
}

const Settings = () => {
  const [openManageDismissedModalId, setOpenManageDismissedModalId] = useState<boolean>();
  const [openGlobalSettingsId, setOpenGlobalSettingsId] = useState<boolean>();

  return (
    <div className="onboardingContainer">
      <div className="mb-3 row col-12">
          <h2 className="font-weight-bold text-nowrap">Manage Settings</h2>
      </div>
      <AccordianContainer 
        className="demographicsAccordion my-3"
        label="Global Settings"
        open={openGlobalSettingsId}
        onClick={() => setOpenGlobalSettingsId(openId => !openId)}
      >
        {openGlobalSettingsId ? <GlobalSettings /> : ''}
      </AccordianContainer>  
      <AccordianContainer 
        className="demographicsAccordion my-3"
        label="Manage Dismissed Modals"
        open={openManageDismissedModalId}
        onClick={() => setOpenManageDismissedModalId(openId => !openId)}
      >
        {openManageDismissedModalId ? <ManageDismissedModals /> : ''}
      </AccordianContainer>
    </div>
  );
};

export default Settings;